/**
 * AudioPlayerWithDuration localized copy — shared shell used by
 * TTS, STT, and Translate playback surfaces.
 * Re-export shim over /locales/{en,ht,fr,es}.json (audio_player key).
 */
import en from '../locales-shared/en.json'
import ht from '../locales-shared/ht.json'
import fr from '../locales-shared/fr.json'
import es from '../locales-shared/es.json'
import ptBR from '../locales-shared/pt-BR.json'
import zhHans from '../locales-shared/zh-Hans.json'

const COPY = {
  en: en.audio_player,
  ht: ht.audio_player,
  fr: fr.audio_player,
  es: es.audio_player,
  'pt-BR': ptBR.audio_player,
  'zh-Hans': zhHans.audio_player,
}

export default COPY
